import { textToBase64 } from './base64';
import { getOkapiBaseUrl } from './getOkapiBaseUrl';

export type TokenResponse = {
  expires_in: number;
  access_token: string;
};

export async function getAccessTokenFromOkapi(scope = 'vastgoed'){
  const apiBaseUrl = getOkapiBaseUrl();

  const apiSecret = textToBase64(
    `${process.env.OKAPI_CLIENT_ID}:${process.env.OKAPI_CLIENT_SECRET}`,
  );

  const params = {
    scope,
    grant_type: 'client_credentials',
  };

  // Build the body parameters
  const body = Object.entries(params)
    .map(([key, value]) => {
      return encodeURIComponent(key) + '=' + encodeURIComponent(value);
    })
    .join('&');

  const response = await fetch(
    `${apiBaseUrl}/invoke/pub.apigateway.oauth2/getAccessToken`,
    {
      method: 'POST',
      body,
      headers: {
        Authorization: `basic ${apiSecret}`,
        'Content-Type': 'application/x-www-form-urlencoded',
      },
    },
  );

  return (await response.json()) as TokenResponse;
}

